import { Ptag } from "components/core/fonts";
import React from "react";
import { theme } from "theme";
import RoomLimit from "./RoomLimit";
import { Label, OuterBox } from "./styles";

const BaseCustomizeInput = ({ label, formikProps }) => {
  return (
    <OuterBox>
      {/* <Ptag fontSize="14px" color={theme.baseBlue} fontWeight="500">
        {label}
      </Ptag> */}
      <RoomLimit formikProps={formikProps} />
    </OuterBox>
  );
};

export default BaseCustomizeInput;
